import axios, { isAxiosError } from "axios"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"
import { FaCircleArrowUp, FaDownLeftAndUpRightToCenter, FaFilter } from "react-icons/fa6"


import { metaCategoriesMen, metaCategories, SuggestionsOptions, SuggestionMap } from '../../constants'
import useAddImageToCollection from "../../hooks/useAddImageToCollection"
import useCollectionNames from "../../hooks/useCollectionNames"
import Design from "./Design"
import DesignImageDiv from "./DesignImageDiv"
import { Box, Chip, Stack } from "@mui/material"
import Loadingwrapper from "../../component/LoadingWrapper"
import useMixpanelTrack from "../../hooks/useMixpanelTracking"
import { FaExpandAlt } from "react-icons/fa"
import SelectFilterCounts from "./SelectFilterCounts"
import { isMobile } from "react-device-detect"
const LIMIT = 100;

const MustHaveDesigns = () => {

  const userLoggedIn = useSelector(state => state.userLoggedIn)
  const [page, setPage] = useState(1)
  const trackMixpanel = useMixpanelTrack()
  const [searchParams, setSearchParams] = useSearchParams({ gender: 'F', category: 'All', argument: 'exact-design-unavaible-in-india,less-copies-in-india,overcrowded-design', occasion: "", pattern: "", texture: "", suggestion: "", sort: "with-color-images" })
  const [designs, setDesigns] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [showGridView, setShowGridView] = useState(true)
  const [showFilterDropdown, setShowFilterDropdown] = useState(false)
  const [loading, setLoading] = useState(true)
  const [designImagesTuples, setDesignImagesTuples] = useState([])
  const [allCollectionNames, socialcollectionSets, retailercollectionSets, getCollectionNames, designProductCollectionSets] = useCollectionNames()
  const [designCounts, setDesignCounts] = useState({})
  const addImageToCollection = useAddImageToCollection()
  const [selectedDesign, setSelectedDesign] = useState(null)
  const updateSearchParam = (key, value) => {
    setSearchParams(prev => {
      prev.set(key, value)
      return prev
    })
  }

  useEffect(() => {
    axios.get(`/api/must-have-designs/design-counts?gender=${searchParams.get('gender')}&category=${searchParams.get('category')}${searchParams.get('argument') ? `&argument=${searchParams.get('argument')}` : ""}&occasion=${searchParams.get('occasion') || ''}&pattern=${searchParams.get('pattern') || ''}&texture=${searchParams.get('texture') || ''}`).then(res => {
      setDesignCounts(res.data)

    })
  }, [searchParams.get('gender'), searchParams.get('category'), searchParams.get('argument'), searchParams.get('occasion'), searchParams.get('texture'), searchParams.get('pattern')])


  useEffect(() => {
    setPage(1)
    setDesigns([])
  }, [searchParams.get('gender'), searchParams.get('category'), searchParams.get('argument'), searchParams.get('argument'), searchParams.get('occasion'), searchParams.get('texture'), searchParams.get('pattern'), searchParams.get('suggestion'), searchParams.get('sort')])

  useEffect(() => {
    const controller = new AbortController()
    getDesigns(controller.signal)
    return () => {
      controller.abort()
    }
  }, [searchParams.get('gender'), searchParams.get('category'), searchParams.get('argument'), page, searchParams.get('occasion'), searchParams.get('texture'), searchParams.get('pattern'), searchParams.get('suggestion'), searchParams.get('sort')])


  useEffect(() => {
    trackMixpanel("Must have designs page open", { gender: searchParams.get('gender'), category: searchParams.get('category') })
  }, [])

  useEffect(() => {
    const newTuples = designs.reduce((previous, currentValue, currIndex, arr) => {
      const lastElementOfPrevious = previous[previous.length - 1]
      if (!lastElementOfPrevious || lastElementOfPrevious.length == (isMobile ? 1 : 3)) {
        previous.push([currentValue])
      } else {
        lastElementOfPrevious.push(currentValue)
      }
      return previous
    }, [])
    setDesignImagesTuples(newTuples)
  }, [designs])

  const socialAddImageToCollectionWrapper = (image, collectionId) => {
    addImageToCollection(image._id, collectionId, socialcollectionSets, 'social', getCollectionNames);
  }

  const retailerAddImageToCollectionWrapper = (image, collectionId) => {
    addImageToCollection(image._id, collectionId, retailercollectionSets, 'retailer', getCollectionNames);
  }

  const SimilarProductsAddImageToCollectionWrapper = (image, collectionId) => {
    addImageToCollection(image.id, collectionId, designProductCollectionSets, 'designsimilarproduct', getCollectionNames);
  }
  useEffect(() => {
    const nextSuggestion = searchParams.get('suggestion')
    if (nextSuggestion && (nextSuggestion.includes("All Quantities") || nextSuggestion.split(',,').length == 3)) {
      setSearchParams(prev => {
        prev.set('suggestion', '')
        return prev;
      })

    }

  }, [searchParams.get('suggestion')])

  const getDesigns = async (signal) => {
    setLoading(true)
    try {
      const resp = await axios.get(`/api/must-have-designs/designs?gender=${searchParams.get('gender')}&category=${encodeURIComponent(searchParams.get('category'))}${searchParams.get('argument') ? `&argument=${searchParams.get('argument')}` : ""}&page=${page}&limit=${LIMIT}&occasion=${searchParams.get('occasion') || ''}&pattern=${searchParams.get('pattern') || ''}&texture=${searchParams.get('texture') || ''}${!searchParams.get('suggestion') || searchParams.get('suggestion') == 'All Quantities' ? '' : `&suggestion=${searchParams.get('suggestion').split(',,').map(item => SuggestionMap[item]).join(',,')}`}&sort=${searchParams.get('sort') || 'recency'}`, { signal })
      setDesigns(prev => [...prev, ...resp.data.trends])
      setTotalCount(resp.data.count)
      setLoading(false)
    } catch (e) {
      if (!isAxiosError(e)) {
        setLoading(false)
        console.error(e)
      }
    }
  }

  const toggleDesignShow = (designId) => {
    setSelectedDesign(prev => {
      if (designId == prev) {
        trackMixpanel("Must have designs page . Expand design ", { gender: searchParams.get("gender"), category: searchParams.get("category"), designId: designId })
        return null
      }
      return designId
    })
  }

  const handleChipClick = (value) => {
    setSearchParams(prev => {
      if (prev.has('argument') && prev.get('argument').includes(value)) {
        trackMixpanel("Must have designs page . Unselect pill " + value, { gender: searchParams.get("gender"), category: searchParams.get("category") })
        prev.set('argument', prev.get('argument').split(',').filter(i => i != value).join(','))
      } else {
        trackMixpanel("Must have designs page . select pill " + value, { gender: searchParams.get("gender"), category: searchParams.get("category") })
        prev.set('argument', prev.has('argument') && prev.get('argument') != "" ? prev.get('argument') + ',' + value : value)
      }
      return prev
    })
  }

  return <div>
    <div className="w-full">
      <h3 className="text-center font-semibold text-xl">Must Have Designs</h3>
      {searchParams.get('argument') == 'less-copies-in-india' ? <p className="text-center">Less copies in India</p> : null}
      {searchParams.get('argument') == 'exact-design-unavaible-in-india' ? <p className="text-center">Exact copy unavailable in India</p> : null}
    </div>
    <div className="w-full px-4 py-3 sticky top-10 bg-white z-40">
      <div className="flex justify-between flex-wrap lg:flex-nowrap w-screen">
        <div className="flex flex-wrap w-screen lg:w-auto">
          <div className="flex ">
            {false ? <select
              value={searchParams.get('gender')}
              onChange={e => {
                updateSearchParam("gender", e.target.value)
                trackMixpanel("Must have designs page. change gender to " + e.target.value, { gender: searchParams.get("gender"), category: searchParams.get("category") })
              }}
              className='rounded bg-slate-200 outline-none border border-slate-400 p-1 mx-1 mt-1'
            >
              <option disabled value={'disabled-gender'}>--gender--</option>
              {
                [{ name: "Female", value: "F" }, { name: "Male", value: "M" }]
                  .filter(gender => designCounts[gender.value] && designCounts[gender.value].totalCount > 0)
                  .map(gender => <option value={gender.value}>{gender.name}</option>)

              }
            </select> : null}
            <select
              value={searchParams.get('category')}
              onChange={e => {
                updateSearchParam('category', e.target.value)
                trackMixpanel("Must have designs page. change category to " + e.target.value, { gender: searchParams.get("gender"), category: searchParams.get("category") })
              }}
              className='rounded bg-slate-200 outline-none border border-slate-400 p-1 mx-1 mt-1'
            >
              <option disabled value={'disabled-category'}>--Category--</option>
              <option key={"All"} value="All">All Categories</option>)
              {
                (searchParams.get('gender') == 'F' ? metaCategories : metaCategoriesMen)
                  .filter(cat => (designCounts && designCounts[searchParams.get('gender')] && designCounts[searchParams.get('gender')][cat] > 0))
                  .map(cat => <option key={cat}>{cat}</option>)
              }
            </select>

          </div>
          <Box >
            <Stack
              direction="row"
              spacing={1}
              marginTop="4px"
              useFlexGap
              sx={{ flexWrap: 'wrap' }}
            >
              {[
                { label: "Exact design unavailable in India", value: "exact-design-unavaible-in-india" },
                { label: "Less copies in India", value: "less-copies-in-india" },
                { label: "Overcrowded design", value: "overcrowded-design" },

              ].map(item => <Chip
                label={item.label}
                variant={searchParams.has('argument') && searchParams.get('argument').includes(item.value) ? 'filled' : 'outlined'}
                color="info"
                onClick={() => {
                  handleChipClick(item.value)
                }}
              />)}
            </Stack>
          </Box>
          <button className="px-4" onClick={() => {
            setShowFilterDropdown(prev => !prev)
          }}>
            <div className="flex justify-center items-center"><FaFilter color={showFilterDropdown ? 'black' : 'gray'} />
            </div>
          </button>

        </div>
        <div className="flex justify-center lg:justify-end font-semibold text-wrap w-screen lg:w-auto">
          Showing 1-{designs.length} of {totalCount} Designs
        </div>
      </div>

      {showFilterDropdown ? <div className="w-full shrink-0 flex flex-wrap border-b my-1 py-1 border-y-slate-200">
        <select
          value={searchParams.get('sort')}
          onChange={e => {
            updateSearchParam('sort', e.target.value)
          }}
          className='rounded bg-slate-200 outline-none border border-slate-400 p-1 mx-1 mt-1 '
        >
          <option disabled value={'disabled-sort'}>--sort--</option>
          <option key={"recency"} value="recency">Recency</option>)
          <option key={"max-review-exact"} value="max-review-exact">Max reviews from exact product</option>)
          <option key={"max-review-total"} value="max-review-total">Max reviews from all product</option>)
          <option key={"with-color-images"} value="with-color-images">Recency with AI images first</option>)
        </select>
        {false ? <div className="mt-1">
          <SelectFilterCounts searchParams={searchParams} setSearchParams={setSearchParams} label="Suggestion" optionsArray={SuggestionsOptions.map(item => ({ value: item }))} field="suggestion" withCount={false} multi={true} />
        </div> : null}
        {
          designCounts && designCounts.filterCounts ? <div className="flex mt-1 flex-wrap w-screen lg:w-auto">
            <SelectFilterCounts searchParams={searchParams} setSearchParams={setSearchParams} label="OCCASIONS" optionsArray={designCounts.filterCounts.occasionCounts} field="occasion" />
            <SelectFilterCounts searchParams={searchParams} setSearchParams={setSearchParams} label="TEXTURES" optionsArray={designCounts.filterCounts.textureCounts} field="texture" />
            <SelectFilterCounts searchParams={searchParams} setSearchParams={setSearchParams} label="PATTERNS" optionsArray={designCounts.filterCounts.patternCounts} field="pattern" />


          </div> : null
        }
      </div> : null}
    </div>
    <div className="fixed bottom-6 right-6 z-50 ">
      <div className="bg-white rounded-full p-0 mb-1">
        <button className="rounded-full bg-[#666] p-3 " onClick={() => {
          setShowGridView(prev => !prev)
        }}>
          {
            !showGridView ?
              <FaDownLeftAndUpRightToCenter size={20} color="white" /> :
              <FaExpandAlt size={20} color="white" />
          }
        </button>

      </div>

      <div className="rounded-full p-0 mb-1">

        <button onClick={() => {
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          })
        }} className="rounded-full w-full h-full p-0 bg-white">
          <FaCircleArrowUp size={44} color="#666" />
        </button>
      </div>

    </div>

    <div>
      <div className="w-full">
        {showGridView ?
          designImagesTuples.map((tup, i) => <div className="w-full mb-6" key={i}>
            <div className="flex w-full ">
              {tup.map(image => <DesignImageDiv design={image} key={image.category + image._id} toggleDesignShow={toggleDesignShow} selectedDesign={selectedDesign} />)}
            </div>
            <div className="w-full">
              {tup.map(design => `${design._id}${design.category}` == selectedDesign ? <Design
                gender={searchParams.get('gender')}
                design={design}
                category={searchParams.get('category')}
                addImageToCollection={socialAddImageToCollectionWrapper}
                addSimilarProductToCollection={SimilarProductsAddImageToCollectionWrapper}
                allCollectionNames={allCollectionNames}
                curator={userLoggedIn.curator ? true : false}
                fetchCollections={getCollectionNames}
                collectionSets={socialcollectionSets}
                designSimilarProductsCollectionSets={designProductCollectionSets}
              /> : null)}
            </div>

          </div>) : designs.map((design, i) => <Design
            key={i}
            gender={searchParams.get('gender')}
            design={design}
            category={searchParams.get('category')}
            addImageToCollection={socialAddImageToCollectionWrapper}
            addSimilarProductToCollection={SimilarProductsAddImageToCollectionWrapper}
            allCollectionNames={allCollectionNames}
            curator={userLoggedIn.curator ? true : false}
            fetchCollections={getCollectionNames}
            collectionSets={socialcollectionSets}
            designSimilarProductsCollectionSets={designProductCollectionSets}
          />)
        }

      </div>

    </div>
    <Loadingwrapper loading={loading}>

      {
        designs.length == 0 ? <div className="flex w-screen h-[40vh] items-center justify-center">
          <div className="text-sm font-semibold italic">No designs found for selected filters</div>

        </div> : <div className="flex py-3 justify-center">
          {
            designs.length == totalCount
              ? <p className="text-center">End Of Results</p>
              : <button className="primary-btn" onClick={() => {
                setPage(prev => prev + 1)
              }}>Load more</button>
          }

        </div>

      }

    </Loadingwrapper>
  </div>
}


export default MustHaveDesigns
